export const DIRECTORY_FILTER_EVENT = "agent_directory_filters_applied";
export const OPEN_HOUSE_VIEW_EVENT = "open_house_viewed";

export type DirectoryFilterSurface = "agent_search" | "vendor_search" | "open_house_explorer" | "agent_listings";
export type ActiveDirectoryFilters = Record<string, string | number | boolean | string[]>;

const REPORTING_PROPERTIES = new Set([
  "token", "$lib", "$lib_version", "$insert_id", "$time", "$config_defaults",
  "distinct_id", "$session_id", "$window_id", "$device_id", "$process_person_profile",
  "app", "release", "org_id", "surface", "route_template",
  "active_filters", "active_filter_count", "result_count", "sort", "view", "snapshot_type", "agent_id",
  "open_house_id", "listing_id", "open_house_start_at", "open_house_end_at", "view_type", "event_id",
]);

/** New reporting events carry explicit IDs/filter values, never automatic URLs or contact fields. */
export function sanitizeDirectoryReportingCapture<T extends {
  event: string;
  properties: Record<string, unknown>;
  $set?: Record<string, unknown>;
  $set_once?: Record<string, unknown>;
}>(capture: T): T {
  if (capture.event !== DIRECTORY_FILTER_EVENT && capture.event !== OPEN_HOUSE_VIEW_EVENT) return capture;
  const sanitized = {
    ...capture,
    properties: Object.fromEntries(Object.entries(capture.properties).filter(([key]) => REPORTING_PROPERTIES.has(key))),
  };
  delete sanitized.$set;
  delete sanitized.$set_once;
  return sanitized;
}
